export enum Checkpoint {
    START = 'START', NETHER_IN = 'NETHER_IN', END_IN = 'END_IN', FINISHED = 'FINISHED', SURRENDERED = 'SURRENDERED'
}


export enum LeaderboardType {
    TEAM = 'team', PLAYERS = 'players'
}
